@use "sass:map";
@use "../../scss/abstracts/breakpoints";
@use "../../scss/abstracts/utilities";


// NOTE: --service-card-color is set as an inline CSS custom property by the component when the color attribute is present.
:host {
  // lighten the default global light shadow
  --light-shadow-color: color-mix(in srgb, var(--sh_gl-shadow-color), transparent 75%);
  --light-shadow: var(--light-shadow-color) var(--sh_gl-shadow-x-offset) var(--sh_gl-shadow-y-offset) var(--sh_gl-shadow-blur);
  display: grid;
  grid-template-rows: auto 1fr;
  border: 1px solid #ccc;
  border-radius: utilities.toRem(8px);
  padding: utilities.toRem(8px);
  background: #fff;
  filter: drop-shadow(var(--light-shadow));
}

.service-card__image {
  margin-block-end: utilities.toRem(8px);
  height: utilities.toRem(230px);
  overflow: hidden;
  border-radius: utilities.toRem(5px);
}

.service-card__body {
  display: grid;
  grid-template:
    "logo" auto
    "content" 1fr
    "cta" auto;
  align-items: start;
  row-gap: utilities.toRem(12px);
  padding-block: utilities.toRem(12px);
  padding-inline: utilities.toRem(16px);
  background-color: var(--service-card-color, transparent);
  border-radius: utilities.toRem(5px);

  .service-card__content {
    grid-area: content;
    color: #fff;
    filter: drop-shadow(var(--light-shadow));
    font-size: 1.2em;
    font-weight: bold;
    text-align: center;
    line-height: 1.2;
    @media (width >= map.get(breakpoints.$grid-breakpoints, "md")) and (width < map.get(breakpoints.$grid-breakpoints, "lg")) {
      font-size: 1em;
    }
  }

  .service-card__cta {
    grid-area: cta;
    align-self: end;
    display: block;
    margin-block-start: utilities.toRem(6px);
    padding-block: utilities.toRem(10px);
    padding-inline: utilities.toRem(20px);
    background: var(--sh_bg-primary);
    border: var(--sh_standard-border);
    border-color: var(--sh_bg-primary);
    border-radius: utilities.toRem(10px);
    filter: drop-shadow(var(--light-shadow));
    font-size: 1.2em;
    font-weight: bold;
    line-height: 1.2;
    text-align: center;
    transition: border-color 0.2s;
    @media (width >= map.get(breakpoints.$grid-breakpoints, "md")) and (width < map.get(breakpoints.$grid-breakpoints, "lg")) {
      font-size: 1em;
    }

    .btn {
      display: block;
      color: var(--sh_fg-primary);
      scale: 1; // Start scaled down to make the transition clearer. This however makes the text slightly blurry in its resting state, but I think it looks better overall.
      text-decoration: none !important;
      transition: scale 0.2s;
      // I'm uncertain if `text-rendering: geometricPrecision;` helps, but `will-change: transform` definitely helps the
      // text animate more smoothly.
      will-change: transform;
      text-rendering: geometricPrecision;
    }

    &:active, &:focus, &:hover {
      border-color: #bbb;

      .btn {
        scale: 1.02;
      }
    }
  }
}

::slotted([slot="image"]) {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

::slotted([slot="content"]) {
  display: block;
}

::slotted([slot="logo"]) {
  width: 100%;
  height: auto;
  filter: drop-shadow(var(--light-shadow));
}
